import BlogPostInterface from '@/structures/interfaces/BlogPostInterface'
import TrafficSignInterface from '@/structures/interfaces/TrafficSignInterface'
import {
  ArchiveInterface,
  ArchiveWithVariants,
} from '@/structures/interfaces/ArchiveInterface'

// Adapter dla BlogPost -> Archive
export function blogPostToArchive(
  blogPost: BlogPostInterface
): ArchiveInterface {
  return {
    slug: blogPost.slug,
    category: {
      slug: blogPost.category.slug,
      title: blogPost.category.name,
    },
    title: blogPost.title,
    excerpt: blogPost.excerpt,
    content: blogPost.content,
    tags: blogPost.tags,
    image: blogPost.image,
  }
}

// Adapter dla TrafficSign -> Archive
// Adapter dla TrafficSign -> Archive
export function trafficSignToArchive(
  trafficSign: TrafficSignInterface
): ArchiveInterface | ArchiveWithVariants {
  // Jeśli znak ma warianty, zwracamy obiekt z wariantami
  if (trafficSign.variants && trafficSign.variants.length > 0) {
    const baseArchive: ArchiveInterface = {
      slug: trafficSign.slug,
      category: {
        slug: trafficSign.category.slug,
        title: trafficSign.category.name,
      },
      title: trafficSign.name,
      excerpt: trafficSign.description,
      tags: trafficSign.meta?.tags || [trafficSign.symbol],
      image: '', // Główny obiekt nie ma obrazu gdy są warianty
    }

    const variants = trafficSign.variants.map((variant) => ({
      ...baseArchive, // Dziedzicz wszystko z base (slug, category, tags, itp.)
      variantId: variant.uuid,
      variantDescription: variant.description,
      title: variant.name || trafficSign.name, // Fallback do głównego name
      excerpt: variant.description || trafficSign.description, // Fallback do głównego description
      image: variant.svg_path,
    }))

    return {
      ...baseArchive,
      variants,
    } as ArchiveWithVariants
  }

  // Pojedynczy znak bez wariantów
  return {
    slug: trafficSign.slug,
    category: {
      slug: trafficSign.category.slug,
      title: trafficSign.category.name,
    },
    title: trafficSign.name,
    excerpt: trafficSign.description,
    tags: trafficSign.meta?.tags || [trafficSign.symbol],
    image: trafficSign.svgPath || 'no-svg',
  }
}

// Adapter dla tablicy BlogPost -> Archive
export function blogPostsToArchive(
  blogPosts: BlogPostInterface[]
): ArchiveInterface[] {
  return blogPosts.map(blogPostToArchive)
}

// Adapter dla tablicy TrafficSign -> Archive (flatten variants)
export function trafficSignsToArchive(
  trafficSigns: TrafficSignInterface[]
): ArchiveInterface[] {
  return trafficSigns.flatMap((sign) => {
    const archiveData = trafficSignToArchive(sign)

    // Jeśli to obiekt z wariantami, zwracamy wszystkie elementy jako płaską tablicę
    if ('variants' in archiveData) {
      return [archiveData as ArchiveInterface, ...archiveData.variants]
    }

    return [archiveData]
  })
}
